import { h } from "preact";
import './input-schedule-styles.scss'
import { Field } from 'react-final-form'
import { ButtonPrimary } from '../../../_common/components/buttons/buttons'
import {useEffect, useState} from 'preact/hooks'
import { FormField, InputField, showError } from '../../../_common/forms/components/components'
import { validationSchedule } from './validation'
import ModalSchedule from './ModalSchedule'
import { t } from '../../../_i18n'

export default function InputSchedule ({ name, onSaveDraft }) {

  const availabilty_options = {
    all_day: t('Todo el día'),
    morning: t('Mañanas'),
    evenoon: t('Tardes'),
    rotative: t('Rotativo')
  }

  const [showModal, setShowModal] = useState(false);
  const showAvailabilityText = (input) => {
    return input.value.from_time && input.value.to_time && input.value.availability && input.value.availability !== 'rotative';
  }

  const showAvailabilityRotativeText = (input) => {
    return input.value.text && input.value.availability === 'rotative';
  }

  return (
    <Field name={name} validate={validationSchedule}>
      {({input, meta})=> (
        <div className={showError(meta) ? 'error' : ''}>
          <div>
              { showAvailabilityText(input) &&
                  <div className='input-schedule-days'>
                    <p>
                      <span className='font-color-149BAB font-bold'> {availabilty_options[input.value.availability] + ': '} </span>
                      <span className="m-t">{input.value.from_time} - {input.value.to_time}</span>
                    </p>
                  </div>
              }
            { showAvailabilityRotativeText(input) &&
                <div className='input-schedule-days'>
                  <p>
                    <span className='font-color-149BAB font-bold'> {availabilty_options[input.value.availability] + ': '} </span>
                    <span>{input.value.text}</span>
                  </p>
                </div>
            }
          </div>
          <div><ButtonPrimary type='button' onClick={() => setShowModal(true)}>{t('Indicar disponibilidad')}</ButtonPrimary></div>
          {showModal && <ModalSchedule visible={showModal}  input={input} onClose={() => setShowModal(false)} onBlur={onSaveDraft} />}
          {showError(meta) && meta.error && <div className='input-schedule-error'>{t('Este campo es obligatorio')}</div> }
        </div>
      )}
    </Field>
  )
}
